/** @jsxImportSource @emotion/react */

import { Outlet } from 'react-router-dom'
import { ImpersonateBanner, ImpersonateProvider } from '../Impersonate'
import FetchCoreContentLayout from './FetchCoreContentLayout'
import Sidebar from './Sidebar'
import * as classes from './styles'

export const PAGE_CONTAINER = 'page-container'

export const Layout = () => (
  <ImpersonateProvider>
    <div css={classes.wrapper}>
      <Sidebar />
      <div id={PAGE_CONTAINER} css={classes.content}>
        <ImpersonateBanner />
        <FetchCoreContentLayout>
          <Outlet />
        </FetchCoreContentLayout>
      </div>
    </div>
  </ImpersonateProvider>
)
